export default "https://assets-v2.scaler.com/packs/files/loudspeaker-IN-IN.4b1c5d.lottie";